export const BENEFIT_LIST_COLORS_DEFINITIONS = {
  yellow: 'bg-sbtyellow-500',
  purple: 'bg-sbtviolet-600',
}
